import { firebaseStorage } from '../plugins/firebase'
import { localStorageService } from './LocalStorageService'

const user = localStorageService.getItem('authenticatedUser')
let accountId

if (user) accountId = user.accountId

const uploadService = (collection) => {
  const uploadFile = async (files) => {
    const uploadedFiles = []
    const dir = `/Maestro/${accountId}/${collection}/`
    console.log(dir, collection, files)
    const ref = firebaseStorage.ref().child(dir)

    const uploads = files.map(async (file, idx) => {
      if (file.uploaded) {
        uploadedFiles.push(file)
      } else {
        const fileName = `${(+new Date())}-${collection}--${idx}.jpg`
        const task = ref.child(fileName).put(file.file)
        const response = await task
        const url = await response.ref.getDownloadURL()

        const newFile = {
          id: file.id,
          size: file.size,
          url: url,
          path: dir + fileName,
          title: '',
          subtitle: '',
          body: '',
          link: '',
          position: idx,
          uploaded: true
        }

        uploadedFiles.push(newFile)

        return newFile
      }
    })

    await Promise.all(uploads)

    return uploadedFiles
  }

  const deleteFile = async (path) => {
    const ref = firebaseStorage.ref().child(path)
    const task = ref.delete()
    const response = await task
    return response
  }

  return {
    uploadFile,
    deleteFile
  }
}

export default uploadService
